var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_5436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 6.27917V14.1667C18.3337 14.8044 18.0901 15.4179 17.6526 15.8819C17.2151 16.3458 16.6169 16.6251 15.9803 16.6625L15.8337 16.6667H4.16699C3.52932 16.6667 2.91573 16.4231 2.45177 15.9856C1.98782 15.5481 1.70857 14.9499 1.67116 14.3133L1.66699 14.1667V6.27917L9.53783 11.5267L9.63449 11.5817C9.74841 11.6373 9.87353 11.6663 10.0003 11.6663C10.1271 11.6663 10.2522 11.6373 10.3662 11.5817L10.4628 11.5267L18.3337 6.27917Z",
    fill: "#6130B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8329 3.33331C16.7329 3.33331 17.5221 3.80831 17.9621 4.52248L9.99961 9.83081L2.03711 4.52248C2.24605 4.18312 2.53312 3.89865 2.87437 3.6928C3.21561 3.48695 3.60114 3.36569 3.99878 3.33915L4.16628 3.33331H15.8329Z",
    fill: "#6130B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_5436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFilled);
export default __webpack_public_path__ + "static/media/mail-filled.63cbe74c3ccbad585685baef520c3566.svg";
export { ForwardRef as ReactComponent };